export const singleOptionToolFunc = tool => {
  const tools = {
    rect: "useRectangleTool",
    roundRect: "useRoundRectTool",
    arrow: "useArrowTool",
    brush: "useBrushTool",
    circle: "useCircleTool",
    curve: "useCurveTool",
    bezier: "useQuadraticBezierTool",
    shapeBrush: "useShapeBrushTool",
    line: "useLineTool"
  };
  let functionName = tools[tool];
  return functionName;
};

export const noOptionToolFunc = tool => {
  const tools = {
    text: "useTextTool",
    pan: "usePanTool",
    pick: "usePickTool"
  };
  let functionName = tools[tool];
  return functionName;
};

export const setDefaultTool = (zwibbler, tool) => {
  let functionName = singleOptionToolFunc(tool);

  if (!functionName) {
    functionName = noOptionToolFunc(tool);
  }
  zwibbler[functionName]();
};



// WEBPACK FOOTER //
// ./src/components/Zwibbler/utils.js